/**
 * Handles tokenization of credit cards
 * @param {Function} tokenizeFunc - Tokenization function
 * @param {boolean} isFormValid - Form validation status
 * @returns {Promise<Object|null>} Tokenized card map or null
 * @throws {Error} If tokenization fails
 */
export const handleCardTokenization = async (tokenizeFunc, isFormValid) => {
  const shouldTokenize = Boolean(tokenizeFunc && isFormValid);

  if (!shouldTokenize) {
    return null;
  }

  try {
    return await tokenizeFunc();
  } catch (tokenizeError) {
    throw new Error(
      'Unable to tokenize the provided credit card. Please review the card details and try again.',
    );
  }
};

export default handleCardTokenization;
